<template>
    <div v-if="can('stations.index')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/transportation-organization" tag="li" class="breadcrumb-item"><a href="">{{i18n('Transportation organization')}}</a></router-link>
                <router-link to="/stations" tag="li" class="breadcrumb-item"><a href="">{{i18n('Bus terminals')}}</a></router-link>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <h1 class="title">{{i18n('Bus terminals')}}</h1>
            </div>
            <div class="base_box_cnt">
                <div class="row">
                    <div class="col-md-8 col-sm-12 col-12">
                        <div class="button-group" v-if="can('stations.create')">
                            <router-link to="/stations/create" class="btn base_btn solid_blue waves-effect waves-light">
                                {{i18n('Create')}}
                            </router-link>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-12 d-none">
                        <form action="" class="search">
                            <div class="base_input_bx">
                                <input type="text" class="form-control base_input" :placeholder="i18n('Filter')">
                                <i class="mdi mdi-magnify"></i>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="base_box_cnt pb-0 form-inline">

            <div class="form-inline">
                <label class="col-form-label fs-12 mr-3" for="to">{{i18n('Station name')}}:</label>
                <input type="text" class="form-control" id="to" @keyup.enter="filterStations()" v-model="to">
            </div>

        </div>

        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_cnt">
                    <div class="responsive-table">
                        <div class="cloading" v-show="isLoading"></div>
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th scope="col">{{i18n('Code')}}</th>
                                <th scope="col">
                                    <button class="w-100 text-left" type="button">{{i18n('Title')}} <span class="float-right d-none"><i class="mdi mdi-arrow-up"></i></span></button>
                                </th>
                                <th scope="col">{{i18n('Region')}}</th>
                                <th scope="col" class="last-th"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="station in stations">
                                <td>{{station.code}}</td>
                                <td>{{station.name}}</td>
                                <td>{{station.location.name}}</td>
                                <td class="text-center">
                                    <router-link v-if="can('stations.edit')" :to="'/stations/update/' + station.id " class="btn-icon">
                                        <i class="mdi mdi-pencil text-primary"></i>
                                    </router-link>
                                    <button v-if="can('stations.delete')" type="button" class="btn-icon" @click="deleteItem(station)">
                                        <i class="mdi mdi-minus-circle text-danger"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <pagination :links="links" :url="'stations'"></pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from "../../components/Pagination";

    export default {
        components: {Pagination},
        data() {
            return {
                isLoading: true,
                stations: [],
                links: {},
                page: 1,
                to: null
            }
        },
        created() {
            this.page = this.$route.params.page;
            this.getStations();
        },
        methods: {
            getStations() {
                this.isLoading = true;
                this.$api.get('stations.index', {
                	page: this.page,
                    to: this.to
                })
                    .then(res => {
                        this.stations = res.data;
                        this.links = res.links;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    })
            },
            deleteItem(item) {
                let indx = this.stations.indexOf(item);
                if (indx >= 0 && confirm(this.i18n('Do you really want to delete this bus station?'))) {
                    this.$api.delete('stations.delete', item.id)
                        .then(res => {
                            if (!res.errors) {
                                this.stations.splice(indx, 1);
                            }
                        })
                }
            },
			filterStations()
            {
            	this.page = 1;
            	this.getStations()
            }
        },
        beforeRouteUpdate(to, from, next) {
            let page = to.params.page;
            if (page) {
                this.page = page;
                this.getStations();
            }
            next();
        }
    }
</script>

<style></style>
